// extracted by mini-css-extract-plugin
export var externalLink = "_9s-0";
export var internalLinkLabel = "_9s-1";